/**
 * Format a date with correct timezone abbreviation using Intl.DateTimeFormat.
 * Replaces dateformat's Z specifier which only supports US timezones.
 *
 * Produces output like "Mar 26, 2026, 3:30 PM AEST" — similar to the old
 * "Mar 26, 2026 @ 3:30 PM EST" format but with correct timezone abbreviations
 * for all locales worldwide.
 *
 * @param {Date|string|number} date - A Date object, ISO string, or timestamp
 * @returns {string} Formatted date string with timezone, or empty string for invalid input
 */
export function formatDateWithTimezone(date) {
  if (date == null) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  });
}

/**
 * Format a date/time with correct timezone for admin-style displays.
 * Replaces dateformat's "mm/dd/yy HH:MM:ss Z" and "mmm dd yy HH:MM:ss Z" patterns.
 *
 * Produces output like "03/26/26, 3:30:45 PM AEST".
 *
 * @param {Date|string|number} date - A Date object, ISO string, or timestamp
 * @returns {string} Formatted date/time string with timezone, or empty string for invalid input
 */
export function formatDateTimeWithTimezone(date) {
  if (date == null) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString(undefined, {
    month: "2-digit",
    day: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short",
  });
}
